import { Components, Theme } from '@mui/material'

declare module '@mui/material/LinearProgress' {
  interface LinearProgressProps {
    size?: 'sm' | 'md' | 'lg'
  }
}

export const MuiLinearProgress: Components<Omit<Theme, 'components'>>['MuiLinearProgress'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.neutralLight[500],
      '& .MuiLinearProgress-bar': {
        borderRadius: theme.shape.borderRadius,
      },
    }),
  },
  variants: [
    {
      props: { size: 'sm' },
      style: {
        height: '6px',
      },
    },
    {
      props: { size: 'md' },
      style: {
        height: '8px',
      },
    },
    {
      props: { size: 'lg' },
      style: {
        height: '10px',
      },
    },
    {
      props: { color: 'success' },
      style: ({ theme }) => ({
        '& .MuiLinearProgress-bar': {
          backgroundColor: theme.palette.success[500],
        },
      }),
    },
  ],
}
